module.exports = __webpack_public_path__ + "img/2120.8790938a.gif";